import { render, staticRenderFns } from "./BankIcon.vue?vue&type=template&id=f106d9fa&scoped=true&"
import script from "./BankIcon.vue?vue&type=script&lang=js&"
export * from "./BankIcon.vue?vue&type=script&lang=js&"
import style0 from "./BankIcon.vue?vue&type=style&index=0&id=f106d9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f106d9fa",
  null
  
)

export default component.exports